import { createStore, combineReducers } from 'redux'
import languageReducer from './reducers/language'
import authReducer from './reducers/auth'
import percentageReducer from './reducers/percentage'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage' 

const rootReducer = combineReducers({language: languageReducer, auth: authReducer, percentage: percentageReducer})

const persistConfig = {
    key: 'root',
    storage,
    blacklist: ['percentage']
  }
   
const persistedReducer = persistReducer(persistConfig, rootReducer)
   
export const store = createStore(persistedReducer)
export const persistor = persistStore(store)
